module.exports = __webpack_public_path__ + "img/USER.e2b69683.svg";